import React from 'react';
import { makeStyles } from 'design-system';
import { IShortcut } from 'react-scale/hooks/useShortcut';
import Kbd from 'design-system/Kbd';

export const Trigger = ({ trigger: value }: Pick<IShortcut, 'trigger'>) => {
  const styles = useStyles();
  const triggers = getKeys(value);

  return (
    <div>
      {triggers.map(t => (
        <div className={styles.trigger} key={t}>
          {(t.length === 1 ? [t] : t.split('+')).map(v => (
            <Kbd key={v}>{(SPECIAL_TRIGGERS as any)[v] || v}</Kbd>
          ))}
        </div>
      ))}
    </div>
  );
};

const getKeys = (key: string) => {
  const isMac =
    typeof navigator !== 'undefined' && navigator.platform.toLowerCase().indexOf('mac') !== -1;

  if (isMac) {
    key = key.replaceAll('alt', 'opt');
    key = key.replaceAll('Alt', 'opt');
  } else {
    key = key.replaceAll('cmd', 'ctrl');
    key = key.replaceAll('Cmd', 'ctrl');
  }

  key = key.replace(/\s/g, '');
  const keys = key.split(',');
  let index = keys.lastIndexOf('');

  for (; index >= 0; ) {
    keys[index - 1] += ',';
    keys.splice(index, 1);
    index = keys.lastIndexOf('');
  }

  return keys;
};

const SPECIAL_TRIGGERS = {
  enter: 'Enter',
  shift: 'Shift',
  backspace: 'Backspace',
};

const useStyles = makeStyles(() => ({
  trigger: {
    flex: 'grow',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: '0.5em',
    '&:last-of-type': {
      marginBottom: 0,
    },
    '& em': {
      color: 'var(--color-RemoGray50)',
      padding: '0 4px',
    },
  },
}));
